import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Dropdown } from 'semantic-ui-react';
import { DropdownOption } from '../../types';
import {withTranslation} from 'react-i18next';
import { savedLanguage } from '../../../util';
import { trackClick } from 'util/firebaseAnalytics';

class Filters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      accounts: this.props.appliedAccounts,
      tags: this.props.appliedTags
    };
  }

  componentWillReceiveProps({ appliedAccounts, appliedTags }) {
    this.setState({
      accounts: appliedAccounts,
      tags: appliedTags
    });
  }

  handleAccountChange = (event, { value }) =>
    this.setState({ accounts: value });
  handleTagsChange = (event, { value }) => this.setState({ tags: value });

  handleResetClick = () => {
    this.setState({
      accounts: [],
      tags: []
    });
  };

  handleApplyClick = () => {
    trackClick('Filter transactions');
    this.props.applyFilters(this.state);
    this.props.toggleFilterModal();
  };

  render() {
    const { t } = this.props;

    return (
      <Modal
        open={this.props.isFilterModalOpen}
        onClose={this.props.toggleFilterModal}
        closeIcon
        size="tiny"
      >
        <Modal.Header textAlign={savedLanguage() === 'sa' || savedLanguage() === 'il' ? "right" : "left"}>{t('transaction.filter_transaction')}</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths="equal">
              <Form.Field>
                <label textAlign={savedLanguage() === 'sa' || savedLanguage() === 'il' ? "right" : "left"}>{t('transaction.account')}</label>
                <Dropdown
                  multiple
                  selection
                  search
                  closeOnChange
                  onChange={this.handleAccountChange}
                  options={this.props.accountOptions}
                  value={this.state.accounts}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field>
                <label textAlign={savedLanguage() === 'sa' || savedLanguage() === 'il' ? "right" : "left"}>{t('labels.categories')}</label>
                <Dropdown
                  multiple
                  selection
                  search
                  closeOnChange
                  onChange={this.handleTagsChange}
                  options={this.props.tagsOptions}
                  value={this.state.tags}
                />
              </Form.Field>
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions textAlign={savedLanguage() === 'sa' || savedLanguage() === 'il' ? "left" : "right"}>
          <Button content={t('buttons.btn_reset')} onClick={this.handleResetClick} />
          <Button content={t('buttons.btn_apply')} onClick={this.handleApplyClick} positive />
        </Modal.Actions>
      </Modal>
    );
  }
}

Filters.propTypes = {
  isFilterModalOpen: PropTypes.bool,
  appliedAccounts: PropTypes.arrayOf(PropTypes.string),
  accountOptions: PropTypes.arrayOf(DropdownOption),
  appliedTags: PropTypes.arrayOf(PropTypes.string),
  tagsOptions: PropTypes.arrayOf(DropdownOption),
  toggleFilterModal: PropTypes.func,
  applyFilters: PropTypes.func
};

export default withTranslation() (Filters);
